export default "__VITE_ASSET__BdL8sgvg__"